import { CircularProgress, FormControl, Grid, MenuItem } from "@material-ui/core";
import BlockIcon from '@mui/icons-material/Block';
import BookmarkAddedIcon from '@mui/icons-material/BookmarkAdded';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import LocalPoliceIcon from '@mui/icons-material/LocalPolice';
import { Autocomplete, Button, TextField } from "@mui/material";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useEffect, useState } from 'react';
import Swal from "sweetalert2";
import PageTitle from '../../../components/PageTitle/PageTitle';
import axios from '../../../utils/axios';

import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));
  
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));
  
  


const SettlementPermissionModify = () => {
    const [userList, setUserList] = useState([]);
    const [userId, setUserId] = useState('');
    const [selectedStatus, setSelectedStatus] = useState('');
    const [loadingIssuers, setLoadingIssuers] = useState(false);
    const [loadingPermission, setLoadingPermission] = useState(false);
    const [permittedStatuses, setPermittedStatuses] = useState([]);
    const StatusList = ["Uploaded","Drafted", "Initiated", "Vetted", "Verified", "Audited", "Approved", "Settled", "Sent_Back", "Bounced","Bulk_Approved","Checklist_Entry"];
    const NoDefaultList = ["Bulk_Approved","Checklist_Entry"];
    const getUsers = async () => {
        setLoadingIssuers(true);
        try {
          const response = await axios.get('/users/by-user-type/Admin_CMSF?take=50');
            setUserList(response.data.payload);
        } catch (error) {
          console.error('Error fetching users:', error);
        }
        setLoadingIssuers(false);
      };
    
    const getPermittedList = async (userID) => {
        setLoadingPermission(true);
        try {
            const response = await axios.get(`/settlement-permissions/user/${userID}`);
            // Assuming the response contains a list of permitted statuses
            setPermittedStatuses(response.data.payload);
        } catch (error) {
            console.error('Error fetching permitted statuses:', error);
        } finally {
            setLoadingPermission(false);
        }
    };
    const savePermission = async () => {
        if (userId==='') {
          Swal.fire({
            customClass: { container: "my-swal" },
            title: "No User Selected",
            html: `
              <div>
                <ul>
                  <li>Please select a user to assign permissions.</li>
                </ul>   
                </div>
            `,
            icon: "warning",
            });
            return;
        }
        if (selectedStatus==='') {
          Swal.fire({
            customClass: { container: "my-swal" },
            title: "No Status Selected",
            html: `
              <div>
                <ul>
                  <li>Please select a permission to assign.</li>
                </ul>   
                </div>
            `,
            icon: "warning",
            });
            return;
        }
        setLoadingPermission(true);
        try {
            const payload = {
                userId: userId,
                claimStatus: selectedStatus
            };
            const response = await axios.post('/settlement-permissions', payload);
            Swal.fire({
                customClass: { container: "my-swal" },
                title: "Permission Saved",
                icon: "success",
                });
            // Refresh the permitted statuses list
            getPermittedList(userId);
        } catch (error) {
            console.error('Error saving permission:', error);
            Swal.fire({ 
                customClass: { container: "my-swal" },
                title: "Error Saving Permission",
                html: ` 
                    <div>
                        <ul>
                            <li>${error.response.data.errorMessages[0]}</li>
                        </ul>
                    </div>
                `,
                icon: "error",
                });
        } finally {
            setLoadingPermission(false);
        }
    };
    const ActivatePermission = async (permissionId) => {
    try{
        const response = await axios.put(`/settlement-permissions/${permissionId}`,{"status": "Active"})
         if(response.data.statusCode === 200){
                Swal.fire({
                    customClass: { container: "my-swal" },
                    title: "Permission Activated",
                    html: `
                        <div>
                            <ul>
                                <li>${response.data.payload.message}</li>
                            </ul>
                        </div>
                    `,
                    icon: "success",
                });
                getPermittedList(userId);
        }
    }
    catch (error){
        console.error('Error activating permission:', error);
        Swal.fire({ 
            customClass: { container: "my-swal" },
            title: "Error Activating Permission",
            html: `
                <div>
                    <ul>
                        <li>${error.response.data.errorMessages[0]}</li>
                    </ul>
                </div>
            `,
            icon: "error",
            });
        }
      

    }
    const DeactivatePermission = async (permissionId) => {
        try{
            const response = await axios.put(`/settlement-permissions/${permissionId}`,{"status": "Deactive"})

        if(response.data.statusCode === 200){
            Swal.fire({
                customClass: { container: "my-swal" },
                title: "Permission Deactivated",
                html: `
                    <div>
                        <ul>
                            <li>${response.data.payload.message}</li>
                        </ul>
                    </div>
                `,
                icon: "success",
            });
            getPermittedList(userId);
        }
        } catch (error){
            console.error('Error deactivating permission:', error);
            Swal.fire({ 
                customClass: { container: "my-swal" },
                title: "Error Deactivating Permission",
                html: `
                    <div>
                        <ul>
                            <li>${error.response.data.errorMessages[0]}</li>
                        </ul>
                    </div>
                `,
                icon: "error",
                }); 
    }
}
const handleMakeDefault = async (permission) => {
  const prevDefault = permittedStatuses.find(p => p.defaultStatus === 1);
  if(prevDefault){
    const permissionId = prevDefault.id;
    try{
            const response = await axios.put(`/settlement-permissions/${permissionId}`,{"defaultStatus": 0})

        } catch (error){
            console.error('Error making default:', error);
    }
  }
    const permissionId = permission.id;
    const permissionName = permission.claimStatus;
        try{
            const response = await axios.put(`/settlement-permissions/${permissionId}`,{"defaultStatus": 1})

        if(response.data.statusCode === 200){
            Swal.fire({
                customClass: { container: "my-swal" },
                title: `${permissionName} made Default Successfully`,
                html: `
                    <div>
                        <ul>
                            <li>${response.data.payload.message}</li>
                        </ul>
                    </div>
                `,
                icon: "success",
            });
            getPermittedList(userId);
        }
        } catch (error){
            console.error('Error making default:', error);
            Swal.fire({ 
                customClass: { container: "my-swal" },
                title: "Error Making Permission Default",
                html: `
                    <div>
                        <ul>
                            <li>${error.response.data.errorMessages[0]}</li>
                        </ul>
                    </div>
                `,
                icon: "error",
                }); 
    }
}




    useEffect(() => {
        getUsers();
        }, []);

  return (
    <div>
        <PageTitle title="Settlement Permissions" />
        <Grid container spacing={2} justifyContent="center" style={{ marginBottom: "15px"}}>
        <Grid item lg={3} md={6} sm={12} xs={12}>
         
            <Autocomplete
              options={userList}
              disableClearable
              getOptionLabel={(option) => `${option.fullName} (${option.empId})`}
              value={userList.find((item) => item.id === userId) || null}
              onChange={(_, newValue) => {
                setUserId(newValue.id );
                getPermittedList(newValue.id);
              }}
              loading={loadingIssuers}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select User"
                  variant="outlined"
                  size="small"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {loadingIssuers ? <CircularProgress size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
          

        </Grid>

        <Grid item lg={2} md={3} sm={6} xs={12} >
          <FormControl fullWidth>
            <TextField
              select
              label="Status"
              name="claimStatus"
              variant="outlined"
              size="small"
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
            >
              {StatusList.map((s) => (
                <MenuItem key={s} value={s}>{s==="Approved" ? "Approved (OMC)" : s==="Sent_Back" ? "Sent Back" : s}</MenuItem>
              ))}
            </TextField>
          </FormControl>
        </Grid>

        

        <Grid item lg={1} md={3} sm={12} xs={12} style={{ textAlign: "center" }} >
          <Button
            variant="contained"
            color="primary"
            style={{marginTop:"5px"}}
            onClick={() => savePermission()}
            // disabled = {userId === '' || selectedStatus === '' || loadingPermission}
          >
            Save
          </Button>

          


        </Grid>
      </Grid>
      {
        permittedStatuses.length ? 
        <>
      <TableContainer component={Paper} style={{marginTop:"25px"}}>
            <Table sx={{ minWidth: 700 }} aria-label="customized table">
            
            <TableRow>
                <StyledTableCell align="center" colSpan={2} >
                    <h3>Permitted Statuses for Selected User</h3>
                </StyledTableCell>
            </TableRow>
          </Table>
        </TableContainer>

            <TableContainer component={Paper} style={{marginTop:"25px"}}>
            <Table sx={{ minWidth: 700 }} aria-label="customized table">
            <TableHead>
              <TableRow>
              
                <StyledTableCell align="center">Permitted Status</StyledTableCell>
                <StyledTableCell align="center">Make Default</StyledTableCell>
                <StyledTableCell align="center">Status</StyledTableCell>
                
                <StyledTableCell align="center">Activate / Deactivate</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              
              {permittedStatuses.map((row) => {
                return (
                  <StyledTableRow key={row.id}>
                    <StyledTableCell align="center">{row.claimStatus}</StyledTableCell>
                    <StyledTableCell align="center">
                      {
                        row.defaultStatus === 1 ? 
                          <Button 
                            variant="outlined"
                            color="primary"
                          >
                            <LocalPoliceIcon/>&nbsp;&nbsp; {'Default'}
                          </Button>
                        :
                          NoDefaultList.includes(row.claimStatus) ?
                          <Button
                            variant="outlined"
                            color="primary"
                            disabled
                          >
                           <BookmarkAddedIcon/>&nbsp;&nbsp; {'Make Default'}
                          </Button>
                          :
                        <Button 
                            variant="outlined"
                            color="primary"
                            onClick={()=>handleMakeDefault(row)}
                            >
                           <BookmarkAddedIcon/>&nbsp;&nbsp; {'Make Default'}
                        </Button>
                      }
                      
                      
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <Button 
                            variant="outlined"
                            color={row.status ? "success" : "error"}
                            >
                            {row.status ? 'Active' : 'Deactive'}
                      </Button>
                    </StyledTableCell>
                    
                    <StyledTableCell align="center">
                        <Button 
                            variant="contained"
                            color="success"
                            title="Activate Permission"
                            onClick={() => ActivatePermission(row.id)}
                            // disabled={row.status}
                            style={row.status ? { display:'none' } : {}}
                            >
                            <CheckCircleIcon/>&nbsp;&nbsp; {!row.status ? 'Activate' : 'Activated'}
                            </Button>
                            
                        <Button 
                            variant="contained"
                            color="error"
                            title="Deactivate Permission"
                            onClick={() => DeactivatePermission(row.id)}
                            // disabled={!row.status}
                            style={!row.status ? { display:'none' } : {}}
                            >
                            <BlockIcon/> &nbsp;&nbsp; {row.status ? 'Deactivate' : 'Deactivated'}
                            </Button>
                    </StyledTableCell>
                  </StyledTableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        </>
        : 
        loadingPermission ?
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <CircularProgress />
        </div>
        :
        null
      }
    </div>
  )
}

export default SettlementPermissionModify;